import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSimCard1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sim-card-1"><path d="M8.75 11.75H15.25V17.25H8.75V11.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M4.75 2.75H14.25L19.25 7.75V21.25H4.75V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconSimCard1;
